module.exports = __webpack_public_path__ + "static/media/googleplay-store.c68b13dc.svg";